/**
 * What a marketplace duration is called, for every admin screen.
 *
 * A duration is not always a count of months: 0 is lifetime, and a negative
 * number is a count of DAYS (-7 is a week). Pages that assumed months showed
 * buyers and staff "-7 months" and "0 months". Mirrors
 * server/product-utils.js#marketplaceDurationLabel.
 */
export function durationLabel(value) {
    const months = Number(value);
    if (!Number.isFinite(months)) return '';
    if (months === 0) return 'Lifetime';
    if (months < 0) return `${-months} day${months === -1 ? '' : 's'}`;
    return `${months} month${months === 1 ? '' : 's'}`;
}

/** The short form, for tight spaces like a dropdown. */
export function durationLabelShort(value) {
    const months = Number(value);
    if (!Number.isFinite(months)) return '';
    if (months === 0) return 'Lifetime';
    if (months < 0) return `${-months}d`;
    return `${months} mo`;
}
